export const transportRouteList = [
    {
      key: "1",
      id: "R124556",
      routes: "Seattle",
      status: "Active",
      statusClass: "badge badge-soft-success",
      addedOn: "15 May 2024",
    },
    {
      key: "2",
      id: "R124555",
      routes: "Brooklyn Central",
      status: "Active",
      statusClass: "badge badge-soft-success",
      addedOn: "14 May 2024",
    },
    {
      key: "3",
      id: "R124554",
      routes: "Rochester",
      status: "Active",
      statusClass: "badge badge-soft-success",
      addedOn: "13 May 2024",
    },
    {
      key: "4",
      id: "R124553",
      routes: "Kansas City",
      status: "Active",
      statusClass: "badge badge-soft-success",
      addedOn: "12 May 2024",
    },
    {
      key: "5",
      id: "RR124552",
      routes: "Brooklyn North",
      status: "Active",
      statusClass: "badge badge-soft-success",
      addedOn: "11 May 2024",
    },
    {
      key: "6",
      id: "RR124551",
      routes: "Port Graham",
      status: "Active",
      statusClass: "badge badge-soft-success",
      addedOn: "10 May 2024",
    },
    {
      key: "7",
      id: "R24550",
      routes: "Nashville",
      status: "Active",
      statusClass: "badge badge-soft-success",
      addedOn: "09 May 2024",
    },
    {
      key: "8",
      id: "R24549",
      routes: "Detroit",
      status: "Inactive",
      statusClass: "badge badge-soft-danger",
      addedOn: "08 May 2024",
    },
    {
      key: "9",
      id: "R124548",
      routes: "Camden",
      status: "Active",
      statusClass: "badge badge-soft-success",
      addedOn: "07 May 2024",
    },
    {
      key: "10",
      id: "R124547",
      routes: "Terra Bella",
      status: "Active",
      statusClass: "badge badge-soft-success",
      addedOn: "07 May 2024",
    },
  ];